import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const CITY_MAX_LENGTH = 30;

export const CITY_SCHEMA_FIELD_NAME = "city";

export const getCityFormFieldSchema = () =>
  yup
    .string()
    .trim()
    .required()
    .alphaSpace()
    .max(CITY_MAX_LENGTH)
    .label(i18n("CityFormField__LABEL").toLowerCase());
